import { render, staticRenderFns } from "./adjuntarLinkFiles.vue?vue&type=template&id=81d9cce8&scoped=true"
import script from "./adjuntarLinkFiles.vue?vue&type=script&lang=js"
export * from "./adjuntarLinkFiles.vue?vue&type=script&lang=js"
import style0 from "./adjuntarLinkFiles.vue?vue&type=style&index=0&id=81d9cce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d9cce8",
  null
  
)

export default component.exports